import { Link } from 'react-router-dom';
import logo from '../es-logo.png';

export default function Logo({ to = '/', showText = true, className = '' }) {
  return (
    <Link to={to} className={`flex items-center gap-3 ${className}`}>
      <img
        src={logo}
        alt="Event Story"
        className="h-11 w-11 rounded-full object-contain drop-shadow-[0_0_12px_rgba(14,124,196,0.6)]"
      />
      {showText && (
        <span className="font-display text-xl font-extrabold tracking-tight">
          <span className="text-gradient">Event</span>{' '}
          <span className="text-white">Story</span>
        </span>
      )}
    </Link>
  );
}
